import {
  compose,
  lifecycle,
  withHandlers,
  withState,
  branch,
  renderComponent,
} from 'recompose';
import { connect } from 'react-redux';

import { getSubcategoryCondidats } from 'actions/categories';

import CandidatsDropdown from './CandidatsDropdown';
import DefaultDropdown from './DefaultDropdown';

const mapDispatchToProps = {
  onInit: getSubcategoryCondidats,
};

const state = compose(withState('initialData', 'setInitialData'));

const refresh = (props) => {
  const { onInit, setInitialData, categoryId } = props;
  return onInit(categoryId).then(setInitialData);
};

const handlers = withHandlers({
  onInit: (props) => () => refresh(props),
});

const retrieveData = lifecycle({
  componentDidMount() {
    this.props.onInit();
  },
});

export default compose(
  connect(
    null,
    mapDispatchToProps
  ),
  state,
  handlers,
  retrieveData,
  branch((props) => !props.initialData, renderComponent(DefaultDropdown))
)(CandidatsDropdown);
